"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrawerDispatch = exports.useDrawerState = exports.DrawerConsumer = exports.DrawerProvider = exports.DrawerContext = void 0;
var react_1 = __importStar(require("react"));
var ControlPanel_1 = __importDefault(require("./ControlPanel"));
var reducers_1 = require("./ControlPanel/util/reducers");
// Used to inject and retrieve drawer state and dispatcher.
exports.DrawerContext = (0, react_1.createContext)({
    state: reducers_1.initialState,
});
exports.DrawerProvider = exports.DrawerContext.Provider;
exports.DrawerConsumer = exports.DrawerContext.Consumer;
function useDrawerController() {
    var _a = __read((0, react_1.useReducer)(reducers_1.drawerReducer, reducers_1.initialState), 2), state = _a[0], dispatch = _a[1];
    return { state: state, dispatch: dispatch };
}
function useDrawerState() {
    var state = (0, react_1.useContext)(exports.DrawerContext).state;
    if (state === undefined) {
        throw new Error('useDrawerState must be used within a Drawer wrapper component');
    }
    return state;
}
exports.useDrawerState = useDrawerState;
function useDrawerDispatch() {
    var dispatch = (0, react_1.useContext)(exports.DrawerContext).dispatch;
    if (dispatch === undefined) {
        throw new Error('useDrawerDispatch must be used within a Drawer wrapper component');
    }
    return dispatch;
}
exports.useDrawerDispatch = useDrawerDispatch;
// Wraps drawer around children components on user page.
function Drawer(_a) {
    var children = _a.children;
    var _b = useDrawerController(), state = _b.state, dispatch = _b.dispatch;
    return (react_1.default.createElement(exports.DrawerProvider, { value: { state: state, dispatch: dispatch } },
        react_1.default.createElement(ControlPanel_1.default, null),
        children));
}
exports.default = Drawer;
